import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MessageService, ConfirmationService } from 'primeng/api';

import { appRoutes } from './app.routes';
import { jwtInterceptor }   from './core/interceptors/jwt.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Change detection optimizado
    provideZoneChangeDetection({ eventCoalescing: true }),

    // Router con lazy loading + view transitions
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withViewTransitions()
    ),

    // HTTP con interceptores funcionales
    provideHttpClient(
      withInterceptors([jwtInterceptor, errorInterceptor])
    ),

    // Animaciones async (no bloquea el bundle inicial)
    provideAnimationsAsync(),

    // PrimeNG servicios globales
    MessageService,
    ConfirmationService
  ]
};
